<template>
  <div>
    <!-- Filtro por periodo -->
    <v-btn-toggle mandatory v-model="period_filter">
      <!-- <v-btn text small class="text-none">Día</v-btn> -->
      <v-btn text small class="text-none">Semana</v-btn>
      <v-btn text small class="text-none">Mes</v-btn>
      <v-btn text small class="text-none">Año</v-btn>
      <!-- <v-btn text small class="text-none">Personalizado</v-btn> -->
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: 'date-tab-filter',
  props: {
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      period_filter: 0,
      selectedPeriod: 'week'
    }
  },
  watch: {
    period_filter: function (value) {
      switch (value) {
        // case 0:
        //   this.getCurrentDates('day')
        //   break
        case 0:
          this.selectedPeriod = 'week'
          this.getCurrentDates('week')
          break
        case 1:
          this.selectedPeriod = 'month'
          this.getCurrentDates('month')
          break
        case 2:
          this.selectedPeriod = 'year'
          this.getCurrentDates('year')
          break
          // case 4:
          //   this.getCurrentDates('week')
          //   break

        default:
          break
      }
    },
    period: function (value) {
      switch (value) {
        case 'week':
          this.period_filter = 0
          break
        case 'month':
          this.period_filter = 1
          break
        case 'year':
          this.period_filter = 2
          break
        default:
          break
      }
    }
  },
  methods: {
    getCurrentDates (type) {
      const currentDate = this.$moment()

      const start = currentDate.clone().startOf(type)
      const end = currentDate.clone().endOf(type)

      this.$emit('update:filter', this.period_filter)
      this.$emit('update:period', this.selectedPeriod)
      this.$emit('update:dates', [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')])
    }
  }
}
</script>
